import { SetShowLoadingIndicatorAction } from '../../types';
import { SET_LOADING_INDICATOR } from '../../constants/actionTypes';

export const setLoadingIndicator = (enable: boolean): SetShowLoadingIndicatorAction => ({
  type: SET_LOADING_INDICATOR,
  isLoadingIndicatorEnabled: enable,
});
